import { Alert, Box, Link } from "@mui/material";

export const IfNeededAlert: React.FC = () => (
  <Box sx={{ px: 2, mb: 2 }}>
    <Alert severity="info" sx={{ textAlign: "center" }}>
      En cas de besoin, veuillez nous contacter par téléphone au{" "}
      <Link href="tel:0149901000" underline="none" color="inherit">
        01 49 90 10 00
      </Link>
      .
    </Alert>
  </Box>
);
